import './manual-input-form-upload.scss';
import { useTranslation } from 'react-i18next';
import { ClbLink } from '@celebration/react';
import IManualInputFormUploadProps from './interfaces/IManualInputFormUploadProps';
import Shape from '../../../../../../../common/components/shape';
import Input from '../../../../../../../common/components/input';
import ValidationService from '../../../../../../../common/services/validation';

function ManualInputFormUpload({
    handleManualInputFormChange,
    inputErrors,
}: Readonly<IManualInputFormUploadProps>) {
    const { t } = useTranslation();

    const helpDataText = t('UploadCargasTextoAjuda');
    const manualInputDataTitle = t('UploadCargas');
    const manualInputDataAuxiliaryText = t('UploadCargasTextoAuxiliar');
    const manualInputUploadCargasArquivo = t('UploadCargasArquivo');
    const manualInputTemplate = t('UploadCargasTemplate');
    const manualInputVariablesExplanation = t(
        'UploadCargasExplicacaoVariaveis',
    );
    const publicUrl = process.env.PUBLIC_URL;

    const renderUploadHelpData = () => {
        return (
            <Shape className="manual-input-help-data-shape">
                <div>
                    <p>{helpDataText}</p>
                    <p>
                        <ClbLink
                            download
                            href={`${publicUrl}/files/Template_Import_CSV.csv`}
                        >
                            {manualInputTemplate}
                        </ClbLink>
                        <ClbLink
                            download
                            href={`${publicUrl}/files/Template_Documentation_pt_br.docx`}
                        >
                            {manualInputVariablesExplanation}
                        </ClbLink>
                    </p>
                </div>
            </Shape>
        );
    };

    const renderFileUploadData = () => {
        return (
            <Shape
                className="manual-input-upload-data-shape"
                dataTestid="manual-input-upload-data-shape"
            >
                <div>
                    <p className="manual-input-upload-title">
                        {manualInputDataTitle}
                    </p>
                    <p>{manualInputDataAuxiliaryText}</p>
                    <p className="manual-input-upload-file-text">
                        {manualInputUploadCargasArquivo}
                    </p>
                    <Input
                        type="file"
                        icon="upload"
                        onChange={handleManualInputFormChange}
                        error={!!inputErrors?._errors}
                        helperText={ValidationService.getError(
                            inputErrors?.fileName,
                            t,
                        )}
                        className="manual-input-upload-input"
                        id="manual-input-upload-input"
                        placeholder="Upload"
                        title="Upload"
                        key="manual-input-upload-input"
                    >
                        Adicione um arquivo
                    </Input>
                </div>
            </Shape>
        );
    };

    return (
        <div className="manual-input-div">
            {renderUploadHelpData()}
            {renderFileUploadData()}
        </div>
    );
}

export default ManualInputFormUpload;
